module.exports = "https://static.wanderu.com/ui-react/_next/static/media/mx.a1b8bb76.svg";